import React, { useState } from "react";
import styles from "./CollapsibleIframe.module.css";

const CollapsibleIframe = ({ src }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="mx-auto">
      <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
        <button
          className={`${isCollapsed ? styles.redButton : ''} d-flex justify-content-center align-items-center`}
          onClick={toggleCollapse}
        >
          {isCollapsed ? "Click here to start the exam" : "Collapse"}
        </button>
      </div>
      {!isCollapsed && (
        <iframe
          width="100%"
          height="50%"
          src={src}
          title="Collapsible Iframe"
        />
      )}
    </div>
  );
};

export default CollapsibleIframe;

